import { isValidElement } from 'react';
import type { IconElement } from '@backstage/frontend-plugin-api';
import { Icon, type IconGlyph, type IconProps } from '@ns/plugin-ns-theme';

/**
 * Reads the glyph out of the icon a page brings, so the sidebar can show the
 * glyph's selected variant on the current item.
 *
 * @remarks
 * Only a bare `<Icon glyph={...} />` counts. A wrapped icon, or one from
 * another library, yields `undefined`, and the sidebar then shows the element
 * as it is. Other props of the `Icon`, such as `size`, do not reach the sidebar.
 *
 * @param icon - The icon of a page, as AppNav delivers it.
 * @returns The glyph, or `undefined` when the icon is not a bare ns-theme `Icon`.
 *
 * @public
 */
export function findGlyph(icon: IconElement): IconGlyph | undefined {
  return isValidElement<IconProps>(icon) && icon.type === Icon
    ? icon.props.glyph
    : undefined;
}
